import React, { useState } from "react";
import { forgotPassword } from "../../features/user/userAPI";
import { toast } from "react-toastify";
import bgImage from "../../assets/images/37.png";
import { Icons } from "../../constants/icon-library";

function ForgotPassword() {
  const [email, setEmail] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      toast.error("Please enter your email");
      return;
    }
    try {
      await forgotPassword({ email });
      toast.success("Reset link sent to your email");
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message || "Something went wrong";
      toast.error(errorMessage);
    }
  };

  return (
    <main className="main" id="top">
      <div className="container-fluid bg-body-tertiary dark__bg-gray-1200">
        <div
          className="bg-holder bg-auth-card-overlay"
          style={{ backgroundImage: `url(${bgImage})` }}
        ></div>
        <div className="row flex-center position-relative min-vh-100 g-0 py-5">
          <div className="col-11 col-sm-10 col-xl-8">
            <div className="card border border-translucent auth-card">
              <div className="card-body pe-md-0">
                <div className="row align-items-center gx-0 gy-7">
                  <div className="col mx-auto py-14">
                    <div className="auth-form-box">
                      <div className="text-center">
                        <a
                          className="d-flex flex-center text-decoration-none mb-4"
                          href="/"
                        >
                          <div className="d-flex align-items-center fw-bolder fs-3 d-inline-block">
                            <img
                              src={
                                localStorage.getItem("phoenixTheme") === "dark"
                                  ? "/assets/img/icons/logo.png"
                                  : "/assets/img/icons/logo-dark.png"
                              }
                              alt="phoenix"
                              width="150"
                            />
                          </div>
                        </a>
                        <h4 className="text-body-highlight">
                          Forgot your password?
                        </h4>
                        <p className="text-body-tertiary mb-5">
                          Enter your email below and we will{" "}
                          <br className="d-md-none" />
                          send you <br className="d-none d-xxl-block" />a reset
                          link
                        </p>
                        <form
                          className="d-flex align-items-center mb-5"
                          onSubmit={handleSubmit}
                        >
                          <input
                            className="form-control flex-1"
                            id="email"
                            type="email"
                            placeholder="Email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                          />
                          <button
                            className="btn btn-primary ms-2"
                            type="submit"
                          >
                            Send
                            <i className={`wb ${Icons("moveLeft")} fs-9 ms-2 mt-1 align-middle`}></i>
                          </button>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}

export default ForgotPassword;
